import React, { useState, useEffect } from 'react';
import Article from './components/Article';

function App() {
  const [articles, setArticles] = useState([]);
  const [subreddit, setSubreddit] = useState('SemenRetention');

  useEffect(() => {
    fetch('https://www.reddit.com/r/' + subreddit + '.json?limit=100').then(
      (res) => {
        if (res.status !== 200) {
          console.log('ERROR');
          return;
        }

        res.json().then((data) => {
          if (data !== null) {
            setArticles(data.data.children);
          }
        });
      }
    );
  }, [subreddit]);

  return (
    <div>
      <div>
        <h1>
          <i class='fas fa-globe-americas'></i>Enter the subreddit you would
          like to visit<i class='fas fa-globe-americas'></i>
        </h1>
      </div>

      <div className='App'>
        <header className='App-header'>
          <input
            type='text'
            className='input'
            value={subreddit}
            onChange={(e) => setSubreddit(e.target.value)}
          />
        </header>
        <div className='articles'>
          {articles != null
            ? articles.map((article, index) => (
                <Article key={index} article={article.data} />
              ))
            : ''}
        </div>
      </div>
    </div>
  );
}

export default App;
